"use client";

import React from "react";

export default function BuildingPage() {
  return (
    <div style={{ width: "100vw", height: "100vh", overflow: "hidden", margin: 0, padding: 0, background: "#0c0c0c" }}>
      <iframe
        src="/models/building/src/index.html"
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        title="Building - Interior Parallax Mapping"
      />
    </div>
  );
}
